import { FlowjoCommons } from '@portal/portal-core';
import { combineReducers } from 'redux';

import { AdminClientReducers } from 'ducks/admin-client';
import { AgreementClientReducers } from 'ducks/agreements-client';
import { authenticationReducer } from 'ducks/auth-client';
import { CustomFieldReducers } from 'ducks/custom-fields';
import { UserClientReducers } from 'ducks/user-client';
import { productVersionReducer } from 'ducks/product-version';
import {
  emailVerification,
  costCenters,
  users,
  products,
  userProductLicenses,
  userAdmin,
} from './cloud-reducers';
import authorizedDevices from './authorized-devices';
import cloudAdmin from './cloud-admin';
import gdpr from './gdpr';
import header from './header';
import navigation from './navigation';
import productTab from './product-tab';
import region from './region';
import superAdmin from './super-admin';
import ui from './ui';
import userAccount from './user-account';

const { alerts } = FlowjoCommons.Alerts.AlertReducers;

const reducers = {
  auth: authenticationReducer,
  emailVerification,
  costCenters,
  authorizedDevices,
  users,
  products,
  userClient: UserClientReducers.CombinedReducer,
  adminClient: AdminClientReducers.CombinedReducer,
  userProductLicenses,
  userAdmin,
  alerts,
  productTab,
  region,
  userAccount,
  cloudAdmin,
  agreements: AgreementClientReducers.AgreementsReducer,
  superAdmin,
  navigation,
  gdpr,
  header,
  ui,
  customFields: CustomFieldReducers,
  productVersion: productVersionReducer,
};

const rootReducer = combineReducers(reducers);

export type RootState = ReturnType<typeof rootReducer>;

export default rootReducer;
